import Vue from 'vue';
import Vuex from 'vuex';
import { oauthInit } from '@/api/oauth';
import { parseOAuths } from '@/lib/utils';
import { OAuths } from '@/enums/oauth';
import modules from './modules';

Vue.use(Vuex);

export function createStore() {
    return new Vuex.Store({
        state: {
            loading: false,
            returnUrl: '',
            platform: null,
            browser: {},
            oauth: {
                list: [], // 当前支持的三方登录
                query: {}, // 三方登录所需的 URL 配置参数（Twitter1.0 除外）
            },
            brandInfo: {
                brandLogoUrl: '', // logo 图表
                brandName: '', // tab title
                webTagBrandLogoUrl: '', // tab favicon.ico
            },
        },
        mutations: {
            setLoading(state, data) {
                state.loading = data;
            },
            setReturnUrl(state, url) {
                state.returnUrl = url;
            },
            setPlatform(state, platform) {
                state.platform = platform;
            },
            setBrowser(state, info) {
                state.browser = info;
            },
            setBrandInfo(state, info) {
                state.brandInfo = info;
            },

            // 处理并保存当前支持的三方登录及其配置
            setOAuths(state, data) {
                const values = parseOAuths(data.loginType);
                const list = Object.keys(OAuths).reduce((prev, key) => {
                    if (values.includes(OAuths[key].value)) {
                        prev.push(OAuths[key]);
                    }
                    return prev;
                }, []);
                Object.assign(state.oauth, { list, query: data.thirdPartyPara });
            },
        },
        actions: {
            // prettier-ignore
            async queryBasicInitialization({ commit }) {
                const { loginType, thirdPartyPara, brandInfo } = await oauthInit({ channel: 'web' });
                commit('setBrandInfo', brandInfo);
                commit('setOAuths', { loginType, thirdPartyPara });
            },
        },
        modules,
    });
}

export default createStore;
